import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import cikData from "../data/cikPageData.json";

const PspPage = () => {
  const [pageData, setPageData] = useState({});
    useEffect(() => {
        if (cikData?.Cik?.length > 0) {
        setPageData(cikData.Cik[0]);
        }
    }, []);
    if (!pageData) return <p>Loading...</p>;

  return (
    <>
        <div className="page-title">
          <div className="container py-5">
            <h2 className="title position-relative">{pageData.serverTitle}</h2>
          </div>
        </div>

        <section className="product-section servers">
          <div className="container">
            <div className="row">
                <div className="col">
                    <div className="section-title text-center">
                        <h2>{pageData.serverSubtitle}</h2>
                    </div>
                    <div className="cta text-center mt-5">
                        <Link className="btn btn-lg custom-trp-btn" to="/colocation-in-koxville"><i class="fa fa-database" aria-hidden="true"></i>&nbsp;SEE PER CABINET SPACE</Link>
                    </div>
                </div>
            </div>
            <div className="row">
                {pageData?.Servers?.length > 0 &&
                    pageData.Servers.map((product, idx) => (
              <div key={idx} className="col-lg-4 col-md-4 col-sm-6 my-5">
                <div className="product-card">
                    <div className="clean-pricing-item">
                        
                        <div className="ribbon"><span>{product.ribbon}</span></div>

                        <table className="table table-bordered pricing-table text-center">
                            <thead>
                                    <tr>
                                    <td><h4>{product.title}</h4><span className="price">{product.price}</span> /mo.<br />{product.setup}<br /><a className="text-light btn btn-custom btn-lg" href={product.order_link}>Order Now</a></td>
                                    </tr>
                                    <tr>
                                    <td><h5>{product.description}</h5></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {product.features.map((feature, i) => (
                                        <tr key={i}>
                                        <td>{feature}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td><a className="toggle collapsed" data-bs-toggle="collapse" href={`#collapseOption${idx}`} aria-expanded="false" aria-controls={`collapseOption${idx}`}>Optional Add-ons<i className="fa fa-caret-down"></i></a></td>
                                    </tr>
                                </tfoot>
                        </table>

                        <div className="collapse" id={`collapseOption${idx}`} aria-expanded="false"> 
                            <table className="table table-bordered text-center table-collapsable">
                            <tbody>
                                {product.addons.map((addon, i) => (
                                    <tr key={i}>
                                        <td>
                                        <strong>{addon.title}</strong>
                                        <br />
                                        {addon.details}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            </table>
                        </div>

                    </div>
                </div>
              </div>
              ))}
              {/*colend*/}
            </div>
          </div>
        </section>

    </>
  );
};

export default PspPage;
